import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { editSchool } from '../../../redux';
import TextField from 'material-ui/TextField';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import './index.css';

function SchoolTile (props) {
    const {
        thisSchool,
        editSchool,
        schools,
        handleSeeMore,
    } = props;

    const [name, setName] = useState("");
    const [status, setStatus] = useState("");
    const [isEditing, setIsEditing] = useState(false);

    useEffect(() => {
        setName(thisSchool.name);
        setStatus(thisSchool.status);
    }, [thisSchool]);

    const handleChange = (e) => {
        setName(e.target.value);
    }

    const handleSubmit = (e) => {
        editSchool(
            {
                name: name,
                status: status
            },
            schools,
            thisSchool._id
        );
        closeSchoolForm();
    }

    const handleDropdownChange = (e) => {
        setStatus(e.target.innerText.trim());
    }

    const openSchoolForm = () => {
        setIsEditing(true);
    }

    const closeSchoolForm = () => {
        setIsEditing(false);
    }

    if (isEditing) {
        return (
            <div className="schoolTile">
                <div className="leftHalf">
                    <TextField
                        hintText="New School Name"
                        name="name"
                        value={name}
                        onChange={handleChange}
                        fullWidth={true}
                        style={{paddingLeft: "0", marginTop: "10px", marginBottom: "0px"}}
                    />
                    <SelectField
                        hintText={"Status"}
                        name="status"
                        value={status}
                        onChange={(e) => handleDropdownChange(e)}
                        fullWidth={true}
                        iconStyle={{paddingLeft: "40%"}}
                        style={{marginBottom: "0px", marginTop: "0px"}}
                    >
                        <MenuItem
                            key={"Inactive"}
                            value={"Inactive"}
                            primaryText={"Inactive"}
                            id="status"
                        />
                        <MenuItem
                            key={"Active"}
                            value={"Active"}
                            primaryText={"Active"}
                            id="status"
                        />
                    </SelectField>
                </div>
                <div className="rightHalf">
                    <button onClick={closeSchoolForm} className="actionButton" style={{display: "block", marginBottom: "10px"}}>Close</button>
                    <button onClick={handleSubmit} className="pink">Save</button>
                </div>
            </div>
        );
    } else {
        return (
            <div className="schoolTile">
                <div className="leftHalf">
                    <h1>{name}</h1>
                    <h3>{status}</h3>
                </div>
                <div className="rightHalf">
                    <button className="pink" onClick={openSchoolForm} style={{marginBottom: "10px"}}>Edit</button>
                    <button className="pink" onClick={handleSeeMore}>See More</button>
                </div>
            </div>
        );
    }
}

export default connect(state => state.root, { editSchool })(SchoolTile);
